export default {
  // Header
  "nav": {
    "home": "首頁",
    "services": "服務",
    "quickOrder": "快速訂購",
    "faq": "常見問題",
    "contact": "聯繫我們",
  },

  // Footer
  "footer": {
    "copyright": "© 2023 GamiFly Tech. 版權所有。",
  },

  // Homepage
  "home": {
    "hero": {
      "headline": "您的想法，變為現實。快速、經濟、專業。",
      "subheadline": "最快24小時內獲得您的產品演示，價格合理實惠。",
      "cta": "開始您的項目"
    },
    "trust": {
      "fast": "24小時快速交付",
      "price": "經濟實惠",
      "team": "專業品質"
    },
    "stats": {
      "delivery": "快速交付",
      "proNumber": "專業",
      "proLabel": "技術團隊",
      "priceNumber": "實惠",
      "priceLabel": "價格保證"
    },
    "howItWorks": {
      "title": "您的項目旅程",
      "step1": "分享您的需求",
      "step2": "24小時內收到您的演示",
      "step3": "滿意後才付款",
      "step4": "獲得項目持續支持",
    },
    "howItWorksDescription": "簡單高效的流程，將您的願景完美呈現，正如您想像的那樣。",
    "whyChooseUs": "您的專屬優勢",
    "whyChooseUsSubtitle": "實現您軟件願景所需的一切 - 快速且經濟實惠。",
    "quickOrder": {
      "title": "準備開始您的項目？",
      "subtitle": "分享您的需求，24小時內收到您的演示和報價。"
    }
  },

  // Trust Section
  "trust": {
    "title": "為何您可以信任我們",
    "subtitle": "您的項目值得最好的服務 - 以下是我們如何為您提供",
    "case": {
      "title": "高達95%客戶滿意度",
      "description": "您的項目將受益於我們為金融、零售、教育等眾多行業提供解決方案的豐富經驗。"
    },
    "team": {
      "title": "您的本地團隊，說您的語言",
      "description": "與我們香港團隊輕鬆溝通，支援粵語、普通話或英語。"
    },
    "price": {
      "title": "清楚了解您的每一筆費用",
      "description": "獲得清晰明確的報價，無隱藏費用 - 完全符合您的預算需求。"
    },
    "support": {
      "title": "您的項目快速交付，並獲持續支持",
      "description": "最快24小時內查看您的演示，並在項目啟動後獲得專屬支持。"
    }
  },

  // Services
  "services": {
    "title": "為您提供的服務",
    "subtitle": "專為您獨特的業務需求量身定制的解決方案",
    "viewAllButton": "查看所有服務",
    "description": "無論您需要什麼技術解決方案，都能以您的業務所需的速度和質量交付。",
    "readMore": "了解更多",
    "whatsIncluded": "包含內容：",
    "features": {
      "appDevelopment": {
        "nativeDevelopment": "原生iOS和Android開發",
        "crossPlatform": "跨平台解決方案（React Native、Flutter）",
        "storeDeployment": "App Store和Play Store部署",
        "backendIntegration": "後端集成和API",
        "pushNotifications": "推送通知和實時功能"
      },
      "webDevelopment": {
        "responsiveDesign": "響應式網頁設計",
        "modernFrameworks": "現代前端框架",
        "ecommerce": "電子商務平台",
        "cms": "內容管理系統",
        "seo": "搜索引擎優化"
      },
      "mobileDevelopment": {
        "customSolutions": "定制移動解決方案",
        "pwa": "漸進式網絡應用（PWA）",
        "mobileFirst": "移動優先設計",
        "touchOptimized": "觸控優化界面",
        "deviceFeatures": "設備特定功能"
      },
      "cloudServices": {
        "infrastructure": "雲基礎設施搭建",
        "database": "數據庫設計和管理",
        "apiDevelopment": "API開發和集成",
        "scalableArch": "可擴展架構",
        "devops": "DevOps和CI/CD流程"
      },
      "technicalSupport": {
        "support247": "24/7技術支持",
        "maintenance": "錯誤修復和維護",
        "monitoring": "性能監控",
        "security": "安全更新",
        "enhancement": "功能增強"
      },
      "uiUxDesign": {
        "interfaceDesign": "用戶界面設計",
        "uxResearch": "用戶體驗研究",
        "wireframing": "線框圖和原型設計",
        "designSystem": "設計系統創建",
        "usability": "可用性測試"
      }
    },
    "appDevelopment": {
      "title": "定制應用開發",
      "shortDescription": "將您的想法轉化為iOS和Android平台的強大移動應用"
    },
    "webDevelopment": {
      "title": "網站開發",
      "shortDescription": "獲得使用現代技術構建的響應式網站或網絡應用"
    },
    "mobileDevelopment": {
      "title": "移動開發",
      "shortDescription": "為您的用戶設備打造原生或跨平台的移動解決方案"
    },
    "cloudServices": {
      "title": "雲服務",
      "shortDescription": "為您的業務設計的可擴展雲解決方案，無論規模大小"
    },
    "technicalSupport": {
      "title": "技術支持",
      "shortDescription": "為您的所有技術需求提供持續維護和支持"
    },
    "uiUxDesign": {
      "title": "UI/UX設計",
      "shortDescription": "以您的用戶為中心設計的美觀、直觀界面"
    }
  },

  // Quick Order
  "quickOrder": {
    "pageTitle": "您的快速訂購",
    "pageDescription": "分享您的需求，24小時內收到您的解決方案和報價。",
    "title": "告訴我們您的項目需求",
    "subtitle": "填寫以下資料以開始。我們將在24小時內與您聯繫。",
    "serviceTypeLabel": "您需要什麼類型的軟件？",
    "budgetLabel": "您的預算範圍是多少？",
    "countryCodeLabel": "國家/地區代碼",
    "phoneLabel": "電話號碼",
    "phonePlaceholder": "輸入您的電話號碼",
    "hkPhoneFormat": "香港電話號碼應為8位數字（例如：12345678）",
    "generalPhoneFormat": "請輸入您的電話號碼（不含國家/地區代碼）",
    "emailLabel": "電子郵件 (選填)",
    "emailOptional": "電子郵件是選填的，但可以幫助我們發送確認信息",
    "descriptionLabel": "簡要描述您的項目需求",
    "descriptionOptional": "添加任何有助於創建您所需產品的詳細信息",
    "charactersUsed": "已使用字符",
    "submitButton": "獲取您的報價",
    "submitError": "發生錯誤。請重試。",
    "privacyNotice": "提交此表單即表示您同意我們的隱私政策和服務條款。",
    "validation": {
      "servicesRequired": "請至少選擇一種服務類型",
      "budgetRequired": "請選擇您的預算範圍",
      "countryCodeRequired": "國家/地區代碼為必填項",
      "phoneRequired": "電話號碼為必填項",
      "phoneInvalid": "請輸入有效的電話號碼",
      "hkPhoneInvalid": "香港號碼必須為8位數字",
      "emailInvalid": "請輸入有效的電子郵件地址",
      "descriptionTooLong": "描述不能超過30,000個字符"
    },
    "success": {
      "title": "感謝您的訂單！",
      "message": "您將在24小時內收到演示和報價。",
      "newOrderButton": "提交另一個訂單"
    },
    "form": {
      "serviceType": "您需要什麼類型的軟件？",
      "budget": "您的預算範圍是多少？",
      "phone": "電話號碼 (必填)",
      "email": "電子郵件 (選填)",
      "description": "簡要描述您的需求",
      "submit": "提交",
      "phoneRequired": "電話號碼為必填項",
      "phoneInvalid": "請輸入有效的電話號碼",
      "emailInvalid": "請輸入有效的電子郵件地址",
      "success": "您會在幾小時內收到我們的回覆",
    },
  },

  // FAQ
  "faq": {
    "title": "您的問題解答",
    "more": "還有更多問題？",
    "contact": "聯繫我們",
    "subtitle": "關於與GamiFly Tech合作您需要了解的一切。找不到您要尋找的答案？歡迎隨時聯繫我們！",
    "stats": {
      "demoDelivery": "演示交付",
      "happyClients": "滿意客戶",
      "languagesSpoken": "語言支持",
      "supportAvailable": "技術支持"
    },
    "categories": {
      "general": {
        "title": "常見問題",
        "questions": "個問題"
      },
      "pricing": {
        "title": "定價與付款",
        "questions": "個問題"
      },
      "timeline": {
        "title": "時間與流程",
        "questions": "個問題"
      },
      "technical": {
        "title": "技術問題",
        "questions": "個問題"
      }
    },
    "questions": {
      "general1": {
        "question": "GamiFly Tech提供什麼服務？",
        "answer": "我們提供全面的軟件開發服務，包括移動應用開發（iOS和Android）、網站開發、雲服務、UI/UX設計和技術支持。我們專門為您的特定業務需求創建定制解決方案。"
      },
      "general2": {
        "question": "你們是否與香港以外的企業合作？",
        "answer": "是的！雖然我們總部位於香港，但我們與全球客戶合作。我們的團隊精通英語、粵語和普通話，無論您身在何處都能確保無縫溝通。"
      },
      "general3": {
        "question": "GamiFly Tech與其他開發公司有什麼不同？",
        "answer": "我們專注於快速交付（24小時內提供演示）、透明定價無隱藏費用、香港本地團隊便於溝通，以及項目完成後的持續支持。我們致力於與客戶建立長期合作關係。"
      },
      "general4": {
        "question": "你們能處理小項目和大型企業解決方案嗎？",
        "answer": "當然可以！我們與需要簡單移動應用的初創公司到需要複雜可擴展解決方案的大型企業都有合作。我們的團隊能適應任何規模和複雜度的項目。"
      },
      "pricing1": {
        "question": "你們的服務費用是多少？",
        "answer": "我們的定價根據項目複雜性和需求而變化。網站開發從HK$8,000起，移動應用從HK$15,000起，UI/UX設計從HK$5,000起。請聯繫我們獲取針對您具體需求的詳細報價。"
      },
      "pricing2": {
        "question": "你們提供固定價格還是按小時計費？",
        "answer": "根據您的偏好和項目類型，我們提供兩種選擇。對於明確定義的項目，我們提供固定價格報價。對於持續開發或需求不斷變化的項目，我們提供有競爭力的小時費率。"
      },
      "pricing3": {
        "question": "有隱藏費用嗎？",
        "answer": "絕對沒有隱藏費用！我們提供透明的前期定價，包括所有開發工作、測試和初始部署。任何額外費用（如第三方服務或託管）都會事先清楚討論並獲得您的批准。"
      },
      "pricing4": {
        "question": "你們接受哪些付款方式？",
        "answer": "我們接受銀行轉賬、PayPal和主要信用卡。對於大型項目，我們通常採用基於里程碑的付款方式，確保雙方在整個開發過程中都感到舒適。"
      },
      "timeline1": {
        "question": "你們多快能交付演示？",
        "answer": "我們以快速周轉時間為榮。對於大多數項目，您將在提供需求後24小時內收到初始演示或原型。這有助於您在承諾完整開發之前可視化解決方案。"
      },
      "timeline2": {
        "question": "你們的典型項目時間表是什麼？",
        "answer": "時間表取決於項目複雜性：簡單網站（1-3週）、移動應用（2-8週）、複雜網絡應用（4-12週）、企業解決方案（3-6個月）。我們為每個項目提供詳細的時間表和里程碑。"
      },
      "timeline3": {
        "question": "你們能應對緊急截止日期嗎？",
        "answer": "可以！我們了解業務緊迫性，通常能滿足緊急截止日期。我們會評估您的需求並提供誠實的時間表。如有必要，我們可以分配額外資源來滿足您的上線日期。"
      },
      "timeline4": {
        "question": "你們如何處理項目更新和溝通？",
        "answer": "我們通過您偏好的溝通方式（WhatsApp、電子郵件、視頻通話）在整個開發過程中提供定期更新。您將可以訪問顯示實時進度的項目儀表板，並可隨時請求更新。"
      },
      "technical1": {
        "question": "你們使用什麼技術？",
        "answer": "我們使用現代、行業標準的技術，包括用於網站的React/Vue.js、用於移動端的React Native/Flutter、用於後端的Node.js/Python、用於託管的AWS/Google Cloud等。我們為每個項目的特定需求選擇最佳技術堆棧。"
      },
      "technical2": {
        "question": "你們提供持續維護和支持嗎？",
        "answer": "是的！我們提供從HK$3,000/月起的全面維護套餐，包括錯誤修復、安全更新、性能監控和功能增強。我們致力於長期支持您的成功。"
      },
      "technical3": {
        "question": "我的數據和知識產權安全嗎？",
        "answer": "絕對安全。我們實施行業標準的安全實踐，為所有項目簽署保密協議，並遵循嚴格的數據保護協議。您的代碼和數據完全保密，完全屬於您。"
      },
      "technical4": {
        "question": "你們能與現有系統集成嗎？",
        "answer": "是的，我們專門從事集成！無論是連接到您現有的CRM、支付系統、數據庫還是第三方API，我們都能確保與您當前的業務工具和工作流程無縫集成。"
      }
    },
    "contactSection": {
      "title": "還有更多問題？",
      "subtitle": "我們的團隊隨時為您提供幫助！通過您偏好的方式與我們聯繫。",
      "getQuote": "獲取快速報價",
      "whatsapp": "WhatsApp聯繫",
      "contact": "聯繫我們"
    }
  },

  // Contact
  "contact": {
    "title": "聯絡我們",
    "description": "有任何問題或想討論您的項目？我們隨時準備幫助您打造出色的作品。",
    "form": {
      "title": "發送訊息",
      "name": "您的姓名",
      "phone": "電話號碼",
      "email": "電子郵件",
      "message": "您的訊息",
      "submit": "發送訊息",
      "sending": "發送中...",
      "success": "感謝您的訊息。我們會在24小時內回覆您。",
      "error": "發生錯誤。請重試或直接聯繫我們。",
      "emailOptional": "選填 - 但有助於我們發送確認郵件",
      "errors": {
        "nameRequired": "請輸入姓名",
        "phoneRequired": "請輸入電話號碼",
        "phoneInvalid": "請輸入有效的電話號碼",
        "emailInvalid": "請輸入有效的電子郵件地址",
        "messageRequired": "請輸入訊息內容"
      }
    },
    "info": {
      "title": "聯絡資訊",
      "whatsapp": "WhatsApp",
      "whatsappDesc": "快速簡便的通訊方式",
      "phone": "電話",
      "phoneDesc": "直接致電聯繫",
      "email": "電子郵件",
      "emailDesc": "發送電子郵件",
      "hours": "營業時間",
      "hoursWeekday": "週一至週五：上午9:00 - 下午6:00 (香港時間)",
      "hoursSaturday": "週六：上午10:00 - 下午4:00 (香港時間)",
      "hoursSunday": "週日：休息",
      "hoursEmergency": "緊急支援：現有客戶24/7服務",
      "languages": "語言",
      "langEnglish": "英語 - 流利",
      "langCantonese": "廣東話 - 母語",
      "langMandarin": "普通話 - 流利",
      "langNote": "我們可以使用您偏好的語言溝通"
    }
  },

  // Legal
  "legal": {
    "privacy": "隱私政策",
    "terms": "服務條款",
  },

  // Common
  "common": {
    "loading": "加載中...",
    "error": "發生錯誤。請重試。",
    "required": "必填",
    "step": "步驟",
    "scrollDown": "向下滾動",
    "next": "下一步",
    "back": "返回",
    "submit": "提交",
    "getQuote": "獲取報價"
  },

  // Language
  "language": {
    "en": "English",
    "zh": "中文",
  },
}; 